export const useCrashlytics = () => {
  return {
    setAttribute: () => void 0,
    setAttributes: () => void 0,
    recordError: () => void 0,
    setUserId: () => void 0,
  };
};
